const defaults = {
  apiPath: '/api',
  methodOverride: false,
  timeout: 30000
};
export default defaults;